import { Fragment } from 'react';
import WidgetToggleMore from './WidgetToggleMore/WidgetToggleMore';

export const WidgetUtils = props => {
  const { showUtils, title, children, toggle } = props;

  return (
    <Fragment>
      {/* {showUtils && <WidgetSearch />} */}
      {children}
      {showUtils && <WidgetToggleMore title={title} toggle={toggle} />}
    </Fragment>
  );
};

export default WidgetUtils;
